import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { IBlazorInteropMessage } from "./blazor-interop.models";

@Injectable()
export class BlazorInteropService {
    fromBlazor$ = new Subject<IBlazorInteropMessage>();
    toBlazor$ = new Subject<{type: string, message: any}>();
    private blazorUrl: string = "/blazor";

    constructor() { }

    getBlazorUrl(): string {
        return this.blazorUrl;
    }

    setBlazorUrl(url: string): void {
        this.blazorUrl = url;
    }

    receiveFromBlazor(event: IBlazorInteropMessage): void {
        if(this.processBlazorEvent(event)) {
            return;
        }
        this.fromBlazor$.next(event);
    }


    sendToBlazor(event: {type: string, message: any}): void {
        this.toBlazor$.next(event);

    }




    private processBlazorEvent(event: {type: string, data: any}): boolean {
        if(event?.type === 'blazor-alert') {
            alert(event.data.details);
            return true;
        }
    }
}
